interface CalenderIconProps
  extends Omit<React.SVGProps<SVGSVGElement>, "width" | "height" | "fill"> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const CalenderIcon: React.FC<CalenderIconProps> = ({
  width = 14,
  height = 15,
  fill = "#1A1A1A",
  style,
  ...props
}) => (
  <svg
    viewBox="0 0 14 15"
    width={width}
    height={height}
    fill="none"
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.7765 14.5H1.22349C0.549402 14.5 0 13.9435 0 13.2607V3.50947C0 2.82667 0.549402 2.27016 1.22349 2.27016H12.7765C13.4506 2.27016 14 2.82667 14 3.50947V13.2607C14 13.9435 13.4506 14.5 12.7765 14.5ZM1.22349 3.25687C1.08517 3.25687 0.974116 3.36936 0.974116 3.50947V13.2607C0.974116 13.4008 1.08517 13.5133 1.22349 13.5133H12.7765C12.9148 13.5133 13.0259 13.4008 13.0259 13.2607V3.50947C13.0259 3.36936 12.9148 3.25687 12.7765 3.25687H1.22349Z"
      fill={fill}
    />
    <path
      d="M13.5129 6.1953H0.487058C0.218202 6.1953 0 5.97428 0 5.70195C0 5.42961 0.218202 5.20859 0.487058 5.20859H13.5129C13.7818 5.20859 14 5.42961 14 5.70195C14 5.97428 13.7818 6.1953 13.5129 6.1953Z"
      fill={fill}
    />
    <path
      d="M9.22099 3.25687C8.95213 3.25687 8.73393 3.03585 8.73393 2.76352V0.993356C8.73393 0.721024 8.95213 0.5 9.22099 0.5C9.48984 0.5 9.70804 0.721024 9.70804 0.993356V2.76352C9.70804 3.03585 9.48984 3.25687 9.22099 3.25687Z"
      fill={fill}
    />
    <path
      d="M4.77902 3.25687C4.51016 3.25687 4.29196 3.03585 4.29196 2.76352V0.993356C4.29196 0.721024 4.51016 0.5 4.77902 0.5C5.04787 0.5 5.26607 0.721024 5.26607 0.993356V2.76352C5.26607 3.03585 5.04787 3.25687 4.77902 3.25687Z"
      fill={fill}
    />
  </svg>
);
